"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultImageSize = exports.MediaBreakpoints = exports.Breakpoint = void 0;
var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["XS"] = 576] = "XS";
    Breakpoint[Breakpoint["SM"] = 768] = "SM";
    Breakpoint[Breakpoint["MD"] = 992] = "MD";
    Breakpoint[Breakpoint["LG"] = 1200] = "LG";
    Breakpoint[Breakpoint["XL"] = 1920] = "XL";
})(Breakpoint = exports.Breakpoint || (exports.Breakpoint = {}));
var respondAbove = function (breakpoint) { return "(min-width: " + breakpoint + "px)"; };
var respondBetween = function (lower, upper) {
    return "(min-width: " + lower + "px) and (max-width: " + (upper - 1) + "px)";
};
exports.MediaBreakpoints = {
    mobile: respondBetween(1, Breakpoint.SM),
    tablet: respondBetween(Breakpoint.SM, Breakpoint.MD),
    notMobile: respondAbove(Breakpoint.SM),
    mobileAndTablet: respondBetween(1, Breakpoint.MD),
    desktop: respondBetween(Breakpoint.MD, Breakpoint.LG),
    notDesktop: respondBetween(1, Breakpoint.MD),
    desktopXl: respondAbove(Breakpoint.LG),
    notDesktopXl: respondBetween(1, Breakpoint.LG),
    allDesktops: respondAbove(Breakpoint.MD),
    default: '',
};
exports.DefaultImageSize = {
    mobile: Breakpoint.SM,
    tablet: Breakpoint.MD,
    notMobile: Breakpoint.LG,
    mobileAndTablet: Breakpoint.MD,
    desktop: Breakpoint.LG,
    notDesktop: Breakpoint.MD,
    desktopXl: Breakpoint.XL,
    notDesktopXl: Breakpoint.LG,
    allDesktops: Breakpoint.XL,
    default: Breakpoint.XL,
};
//# sourceMappingURL=constants.js.map